import { EditIcon, TrashIcon } from "@xola/icons";
import { Badge } from "@xola/ui-kit";
import pluralize from "pluralize";
import React from "react";
import { Experience, ExperienceOption } from "types";
import { DeleteExperienceOptionModal } from "./DeleteExperienceOptionModal";
import { EditExperienceOptionModal } from "./EditExperienceOptionModal";
import { NoTranslate } from "@/components/Common/NoTranslate";
import { SecondaryButton } from "@/components/Common/SecondaryButton";
import { useModal } from "@/hooks/useVisibility";

interface ExperienceOptionItemProps {
    experience: Experience;
    option: ExperienceOption;
    scheduleCount: number;
}

export const ExperienceOptionItem = React.memo(({ experience, option, scheduleCount }: ExperienceOptionItemProps) => {
    const editModal = useModal(false);
    const deleteModal = useModal(false);

    return (
        <div className="flex w-full items-center justify-between py-4" data-testid="experience-option-item">
            <NoTranslate className="text-md font-bold" data-testid="experience-option-name">
                {option.name}
            </NoTranslate>
            <div className="flex items-center space-x-4">
                <Badge size="medium" color="secondary">
                    <span className="flex items-center gap-1" data-testid="experience-option-schedule-count">
                        <var data-var="scheduleCount">{scheduleCount}</var>
                        <span>{pluralize("schedule", scheduleCount)}</span>
                    </span>
                </Badge>
                <div className="flex items-center space-x-1.5">
                    <SecondaryButton size="small" data-testid="experience-option-edit-button" onClick={editModal.show}>
                        <EditIcon />
                    </SecondaryButton>
                    <SecondaryButton
                        size="small"
                        data-testid="experience-option-delete-button"
                        onClick={deleteModal.show}
                    >
                        <TrashIcon />
                    </SecondaryButton>
                </div>
            </div>
            <EditExperienceOptionModal
                experience={experience}
                option={option}
                isOpen={editModal.isVisible}
                onClose={editModal.hide}
            />
            <DeleteExperienceOptionModal
                experience={experience}
                option={option}
                isOpen={deleteModal.isVisible}
                onClose={deleteModal.hide}
            />
        </div>
    );
});

ExperienceOptionItem.displayName = "ExperienceOptionItem";
